import { useState } from "react";
import { Search } from "../../assets/icons/Search";
import { Close } from "../../assets/icons/Close";

const SearchInput = ({ search, setSearch, placeholder, containerStyle }) => {
  const [value, setValue] = useState(search);
  const [timeoutId, setTimeoutId] = useState(null);

  const handleSearchChange = (e) => {
    setValue(e.target.value);
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    const newTimeoutId = setTimeout(() => {
      setSearch(e.target.value);
    }, 400);
    setTimeoutId(newTimeoutId);
  };

  const clearSearch = () => {
    setValue("");
    setSearch("");
  };

  return (
    <div className="search-container position-relative" style={containerStyle}>
      <input
        placeholder={placeholder}
        className="form-control"
        onChange={handleSearchChange}
        value={value}
        onClick={(e) => e.target.select()}
      />
      <Search size={16} />
      <button
        className="no-style"
        onClick={clearSearch}
        style={{ height: 36, width: 36 }}
      >
        <Close size={16} />
      </button>
    </div>
  );
};

export default SearchInput;
